import {defineStore} from 'pinia'
import CustomStore from "devextreme/data/custom_store";
import { useArsipListStore } from "@/stores/views/arsip-list-store";
import _ from "lodash";
import axios from "axios";
import {API_BASE_URL} from "@/global-constants";
import api from "@/api";
import { useRoute } from "vue-router";
export const useArsipListModel  = defineStore(
    'arsipListModel',
    () => {
        const route = useRoute();
        const columns = ['arsip_kategoris','arsip_pegawais', 'arsips', 'arsip_dewas'];
        
             
        function convertColumnName(name) {
            //mengubah _ menjadi .
            for (const column of columns) {
                const pattern = new RegExp(`^${column}_`);
                if (pattern.test(name)) {
                    return name.replace(pattern, `${column}.`);
                }
            }
            return name;
        }
        
        // function convertArrayElementsASLI(arr, columns) {
        //     return _.map(arr, element => {
        //         console.log("debug convertArrayElements element", element);
        //         if (_.isArray(element) && element.length === 3) {
        //             const [field, operator, value] = element;
        //             if (field === 'arsip_kategori_id' && operator === '=' && _.isString(value)) {
        //                 const newField = 'arsip_kategoris.nama';
        //                 const newOperator = 'contains';
        //                 return [newField, newOperator, value];
        //             }
        //         } 
        //         else if (_.isArray(element)) {
        //             return convertArrayElements(element, columns);
        //         } else if (_.isString(element)) {
        //             return convertColumnName(element, columns);
        //         }
        //         return element;
        //     });
        // }

        

        // const conversionMappingsLAMA = {
        //     'arsip_kategori_id': {
        //         newField: 'arsip_kategoris.nama',
        //         newOperator: 'contains',
        //         check: (field, operator, value) => field === 'arsip_kategori_id' && operator === '=' && _.isString(value)
        //     },
           
        //     'arsip_pegawais_pegawai_ids': {
        //         newField: 'arsip_pegawais.pegawai_id',
        //         newOperator: '=',
        //         check: (field, operator, value) => field === 'arsip_pegawais_pegawai_ids' && operator === '=' && _.isInteger(value)
        //         // check: (field, operator, value) => field === 'arsip_pegawais_pegawai_ids'
        //     },
        // };

       
        
        // function convertArrayElementslama(arr, columns) {
        //     return _.map(arr, element => {
        //         if (_.isArray(element) && element.length === 3) {
        //             const [field, operator, value] = element;
                   
        //             for (const key in conversionMappings) {
        //                 if (conversionMappings[key].check(field, operator, value)) {
        //                     const newField = conversionMappings[key].newField;
        //                     const newOperator = conversionMappings[key].newOperator;
        //                     return [newField, newOperator, value];
        //                 }
        //             }
        //         }
        
        //         if (_.isArray(element)) {
        //             return convertArrayElements(element, columns);
        //         } else if (_.isString(element)) {
        //             return convertColumnName(element, columns);
        //         }
        
        //         return element;
        //     });
        // }

       

     

        function convertArrayElements(arr){
            for (let i = 0; i < arr.length; i++) {
                if (Array.isArray(arr[i])) {
                    // console.log("DEBUGBARU 1 RECURSIVE", arr[i]);
                    convertArrayElements(arr[i]); // Recurse into nested arrays
                } else if (arr[i] === 'arsip_pegawais_pegawai_ids') {
                    // Check if the next two elements are present
                    // console.log("DEBUGBARU 2 IS PEGAWAI_IDS", arr[i]);
                    if (typeof arr[i + 1] === 'string' && typeof arr[i + 2] === 'string') {
                        // Modify the values if conditions are met
                        arr[i] = 'simpeg_pegawais.nama';
                        arr[i + 1] = 'contains';
                        // console.log("DEBUGBARU 3 CHANGE THE ARR", arr[i]);
                    }else{
                        arr[i] = 'arsip_pegawais_pegawai_id';
                        arr[i + 1] = '=';
                        // console.log("DEBUGBARU 4 CHANGE THE ARR", arr[i]);
                    }
                } else if (arr[i] === 'arsip_dewas_dewas_ids') {
                    // Check if the next two elements are present
                    // console.log("DEBUGBARU 2 IS PEGAWAI_IDS", arr[i]);
                    if (typeof arr[i + 1] === 'string' && typeof arr[i + 2] === 'string') {
                        // Modify the values if conditions are met
                        arr[i] = 'dewas.nama';
                        arr[i + 1] = 'contains';
                        // console.log("DEBUGBARU 3 CHANGE THE ARR", arr[i]);
                    }else{
                        arr[i] = 'arsip_dewas_dewas_id';
                        arr[i + 1] = '=';
                        // console.log("DEBUGBARU 4 CHANGE THE ARR", arr[i]);
                    }
                }
                if (_.isString(arr[i])) {
                    // console.log("DEBUGBARU 5 IS STRING", arr[i]);
                    arr[i] =  convertColumnName(arr[i]);
                }

            }

            return arr;
        }





        function convertArrayTgl(loadArray) {
            
            _.forEach(loadArray, (item, index) => {
                if(item instanceof Date){
                     loadArray[index]= formatDateToISOString(item);
                }
                
              });

              let newValues = _.mapKeys(loadArray, (value, key) => {
                return key.replace('arsips_', '');
              });

              return newValues;
        }

        function convertFilterArrayPegawaiBersangkutan(filterArray) {
            // Check if there are multiple conditions for 'arsip_pegawais.pegawai_id'
            let foundMultipleConditions = 0;
            const updatedFilter = filterArray.map((item, index) => {
                if (Array.isArray(item) && item[0] === 'arsip_pegawais.pegawai_id') {
                    if (foundMultipleConditions) {
                        // Change the previous 'and' to 'or'
                        filterArray[index - 1] = 'or';
                    }
                    foundMultipleConditions += 1;
                }
                if (Array.isArray(item) && item[0] === 'arsip_dewas.dewas_id') {
                    if (foundMultipleConditions) {
                        // Change the previous 'and' to 'or'
                        filterArray[index - 1] = 'or';
                    }
                    foundMultipleConditions += 1;
                }

                return item;
            });
            
            //khusus di pegawai_detail_custom, karena di last array ada filter pegawai_id
            let lastIndexAnd = updatedFilter.length - 2;
            if(updatedFilter[lastIndexAnd] === 'and' && updatedFilter[lastIndexAnd+1][0] === 'arsip_pegawais.pegawai_id' && foundMultipleConditions > 1){
                updatedFilter[lastIndexAnd] = 'or';
            }

            if(updatedFilter[lastIndexAnd] === 'and' && updatedFilter[lastIndexAnd+1][0] === 'arsip_dewas.dewas_id' && foundMultipleConditions > 1){
                updatedFilter[lastIndexAnd] = 'or';
            }
            return updatedFilter;

            
        }

        function processFilterArray(filterArray) {
            let extractedValues = [];
        
            function processArray(array) {
                for (let i = 0; i < array.length; i++) {
                    const element = array[i];
        
                    // Check for nested arrays and process recursively
                    if (Array.isArray(element)) {
                        processArray(element);
        
                        // Remove empty arrays
                        if (element.length === 0) {
                            array.splice(i, 1);
                            i--; // Adjust index after removal
                        }
                    }
        
                    // Check for "arsip_dewas" or "arsip_pegawais"
                    if (element === "arsip_dewas" || element === "arsip_pegawais") {
                        // Add to extracted values
                        extractedValues.push(element);
        
                        // Remove the element and any associated "and"/"or"
                        if (i > 0 && (array[i - 1] === "and" || array[i - 1] === "or")) {
                            array.splice(i - 1, 2); // Remove "and"/"or" and the target element
                        } else {
                            array.splice(i, 1); // Remove the target element
                        }
                        i--; // Adjust index after removal
                    }
                }
            }
        
            // Make a copy of the array to avoid mutating the original
            const cleanedArray = JSON.parse(JSON.stringify(filterArray));
            processArray(cleanedArray);
        
            // Remove dangling logical operators at the top level
            for (let i = 0; i < cleanedArray.length; i++) {
                if (cleanedArray[i] === "and" || cleanedArray[i] === "or") {
                    cleanedArray.splice(i, 1);
                    i--; // Adjust index after removal
                }
            }
        
            return { cleanedArray, extractedValues };
        }
        
     
        
        
        
   
        

        // function convertFilterArrayPegawaiBersangkutanLama(filterArray) {
        //     const pegawaiIdCount = countOccurrences(filters, 'arsip_pegawais.pegawai_id');
        //     const hasMultiplePegawaiIds = pegawaiIdCount > 1;
        //     if(hasMultiplePegawaiIds){
        //         let lastIndexAnd = filterArray.length - 2;
        //         if(filterArray[lastIndexAnd] === 'and' && filterArray[lastIndexAnd+1][0] === 'arsip_pegawais.pegawai_id'){
        //             filterArray[lastIndexAnd] = 'or';
        //         }
        //     }

        //     return filterArray;

        // }





    


        const arsipListCustomStore = new CustomStore({
            key: 'arsips_id',
            insert: async (values) => {
                values = convertArrayTgl(values);
                try {
                 const response = await axios.post(`${API_BASE_URL}/customstore-arsips/insert`, {values: values}, {
                     headers: {
                         Authorization: api.defaults.headers.common['Authorization'],
                         'Content-Type': 'application/json',
                     },
                 });
                 if (response.data) {
                     return response.data.data;
                 }
             } catch (error) {
                 console.error('Insert error:', error);
                 throw JSON.stringify(error.response.data.message, null, 2);
             }
             },
             update: async (key, values) => {
                values = convertArrayTgl(values);
               try {
                const response = await axios.post(`${API_BASE_URL}/customstore-arsips/insert`, {values : values, id : key}, {
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });
                if (response.data) {
                    return response.data.data;
                }
            } catch (error) {
                console.error('Update error:', error);
                throw JSON.stringify(error.response.data.message, null, 2);
         
            }
            },
            remove: async(key) => {
                try {
                    const response = await axios.delete(`${API_BASE_URL}/customstore-arsips/${key}`, {
                        headers: {
                            Authorization: api.defaults.headers.common['Authorization'],
                            'Content-Type': 'application/json',
                        },
                    });
                    if (response.data) {
                        return true;
                    }
                } catch (error) {
                    console.error('Insert error:', error);
                    throw JSON.stringify(error.response.data.message, null, 2);
             
                }

            },

            load: async (loadOptions) => {
               
                     // Example usage
       
                     const { cleanedArray, extractedValues } = processFilterArray(loadOptions.filter);
       
               

                const arsipListStore  = useArsipListStore();
                let params = {};
                loadOptions.filterDefault = [];
                loadOptions.filter = cleanedArray;
               loadOptions.filterDefault = extractedValues;
                params.sort = "";params.filter="";
                if (loadOptions.sort) {
                    if (typeof loadOptions.sort[0].selector === 'function') {
                        loadOptions.sort[0].selector= loadOptions.sort[0].selector.context.column.dataField;
                    }
                    params.sort = JSON.stringify(convertArrayElements(loadOptions.sort, columns));
                }
               
                
                if (loadOptions.filter) {
                    if(loadOptions.filter[0] === "arsip_pegawais" || loadOptions.filter[0] === "arsip_dewas"){
                        loadOptions.filterDefault = loadOptions.filter;
                        loadOptions.filter = "";
                    }

                    loadOptions.filter = processLoadArray(loadOptions.filter); //benerin format tanggal
                    let temp = [];
                    if(route.query.filter && arsipListStore.state){
  
                       temp = route.query.filter;
                    }else{
                   
                        temp = removeFilterCriteria( loadOptions.filter, 'pegawai_id');
                    }
                    temp = convertArrayElements(loadOptions.filter, columns);
                    let temp2 = convertFilterArrayPegawaiBersangkutan(temp);
                    let filterString = JSON.stringify(temp2);
                     params.filter = filterString.replace(/arsip_pegawais\.pegawai_ids/g, 'arsip_pegawais.pegawai_id');
                     params.filter = filterString.replace(/arsip_dewas\.dewas_ids/g, 'arsip_dewas.dewas_id');

                    if(params.filter === "[arsip_dewas]"){
                        params.filter = "";
                    }

                }


                


               // ================FILTER DEFAULT --> filter pegawai yang aktif
               
                if(params.filter === ""){
                    // loadOptions.filterDefault.push(['simpeg_pegawais.status_aktif_id', '=', '1']);
                }
               
              
                params.filterDefault = JSON.stringify(loadOptions.filterDefault );

                //================SORT DEFAULT --> sort jabatan_id asc, nik
                loadOptions.sortDefault = [];
                // if(!params.sort.includes("jabatans.nama")){
                //     loadOptions.sortDefault.push({"selector":"jabatans.id","desc":false});
                // }
                // if(!params.sort.includes("nik")){
                //     loadOptions.sortDefault.push({"selector":"nik","desc":false});
                // }
                const hasOnlyTableId = loadOptions.sort && loadOptions.sort.length === 1 && _.get(loadOptions.sort[0], 'selector') === 'arsips_id';

               
                if(params.sort === "" || hasOnlyTableId){
                    loadOptions.sortDefault.push({"selector":"tgl","desc":true});
                 
                    params.sort = "";
                }
                    
                params.sortDefault = JSON.stringify(loadOptions.sortDefault );
                // params.sort = params.sortDefault; //testing

                ////////////////////////////////////

                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }

                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }

             

            //    params.filter =  replaceKeyInArray(params.filter);
               

                const response = await axios.get(`${API_BASE_URL}/customstore-arsips`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });

                
        
          
              
                if (response.data) {

                  
                
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
               
                    };
                }

                throw 'Data loading error';
            },
        });



        function removeFilterCriteria(filter, field) {
            // Check if filter is an array
            if (Array.isArray(filter)) {
              // Check if filter is a single array condition and matches the field criteria
              if (filter.length >= 3 && filter[0] === field) {
                return []; // Return an empty array to remove this filter condition
              } else {
                // Filter out sub-filters that match the field to remove
                return filter.filter(subFilter => {
                  // Recursively apply the function to nested arrays
                  if (Array.isArray(subFilter)) {
                    return removeFilterCriteria(subFilter, field).length > 0; // Keep if not empty after filtering
                  }
                  // Keep other elements (like 'and', 'or', etc.)
                  return true;
                }).map(subFilter => {
                  // Recursively apply the function to nested arrays
                  if (Array.isArray(subFilter)) {
                    return removeFilterCriteria(subFilter, field);
                  }
                  return subFilter;
                });
              }
            }
            // Return the filter as-is if it's not an array or doesn't match the expected structure
            return filter;
          }
          
       

        function processLoadArray(loadArray) {
            return _.map(loadArray, item => {
                if (_.isArray(item)) {
                    // Check if 'periode_absen' is present in the sub-array
                    if (_.includes(item, 'tgl_mulai_bekerja') || _.includes(item, 'tgl_lahir') || _.includes(item, 'pensiun_tgl') || _.includes(item, 'tgl')) {
                        // Map through the sub-array to find and convert Date objects
                        return _.map(item, subItem => {
                            return subItem instanceof Date ? formatDateToISOString(subItem) : subItem;
                        });
                    } else {
                        // Recursively process nested arrays
                        return processLoadArray(item);
                    }
                }
                return item;
            });
        }

        

        function formatDateToISOString(date) {
            function pad(n) { return n < 10 ? '0' + n : n }
            return date.getFullYear() + '-' +
                pad(date.getMonth() + 1) + '-' +
                pad(date.getDate());
        }


        return {
            arsipListCustomStore,
           
        }
    });